export const parseQueryParams = (query: string): { [key: string]: string } => {
  return query
  .split('&')
  .map(part => part.split('='))
  .reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {} as { [key: string]: string });
}

export const parseCustomQuery = (str: string): { [key: string]: string } => {
  const parts = str.split('__');
  const result: { [key: string]: string } = {};

  for (const part of parts) {
    const [key, value = ''] = part.split('=');
    result[key] = value;
  }

  return result;
}
